<template>
    <div>
        <list-container :header="translate('remInboxList.jobsSendWithKEP')" v-show="!$route.params.id">
            <template v-slot:commands>
                <button class="btn btn-primary float-right" @click="$router.push({ name:'DraftDetail', params: { id: '000000000000000000000000' } })">
                    {{translate('draft.newJob')}}
                </button>
            </template>
            <div class="rbcontent">
                <form @submit.prevent="applyFilter()">
                    <div class="row">
                        <div class="col-2">
                            <label>{{translate('reportFilter.trackingNo')}}</label>
                            <div class="input-group input-group-sm mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">{{$route.params.accountCode.toUpperCase()}}</span>
                                </div>
                                <input type="number" v-model="filterForm.Number" class="form-control form-control-sm" placeholder="No">
                            </div>
                        </div>
                        <div class="col-3">
                            <label>{{translate('reportFilter.jobName')}}</label>
                            <input type="text" @input="checkInput('Title',$event)" v-model="filterForm.Title" class="form-control form-control-sm" >
                        </div>
                        <div class="col-2">
                            <button style="margin-top:30px;" type="submit" class="btn btn-sm btn-secondary">{{translate('remInboxList.filter')}}</button>
                        </div>
                    </div>
                </form>
            </div>
            <list ref="jobList" @onload="$emit('onload')" :columns="columns" url="/job/get" modelName="Rem" :hideDeleteCommand="true" :filter="baseFilterObject"  orderBy="TrackingNo.Number desc" :predicate="predicate">

            </list>
        </list-container>
        <router-view v-if="$route.params.id"/>
    </div>
</template>

<script>
import Vue from 'vue'
import list from '../components/List.vue'
import listContainer from '../components/ListContainer.vue'

export default {
    data(){
        return {
            user: null,
            filterForm: { },
            baseFilterObject: { ListType : 'Rem' },
            predicate: "",
            columns : [
                {
                    Key: "TrackingNo",
                    Title: this.translate('reportFilter.trackingNo'),
                    SortField: "TrackingNo.Number",
                    Content(i) {
                        return Vue.filter('trackingNo')(i.TrackingNo);
                    }
                },
                {
                    Key: "Title",
                    Title: this.translate('reportFilter.jobName'),
                    SortField: "Title"
                },
                {
                    Key: "Owner",
                    Title: this.translate('reportFilter.starter'),
                    //SortField: "Owner.Fl, Owner.LastName",
                    Content(i) {
                        return `${i.Owner.FirstName} ${i.Owner.LastName}`
                    }
                },
                {
                    Key: "StartDate",
                    Title: this.translate('draftEyp.date'),
                    SortField: "StartDate",
                    Content(i) {
                        return Vue.filter('datetime')(i.StartDate);
                    }
                },
                {
                    Key: "State",
                    Title: this.translate('jobFinalizer.state'),
                    SortField: "State",
                    Style: "width:125px",
                    Content(i) {
                        return Vue.filter('jobStatus')(i.State);
                    }
                },
            ]
        }
    },
    components: {
        list,
        listContainer
    },
    methods: {
        checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.filterForm, value, editedText)
            } else {
                this.$set(this.filterForm, value, event.target.value)
            }
        },
        applyFilter(){
            var parts = [];

            if(this.filterForm.Number)
                parts.push(`TrackingNo.Number == ${this.filterForm.Number}`);

            if(this.filterForm.Title)
                parts.push(`Title.Contains("${this.filterForm.Title}")`);


            this.predicate = parts.join(" && ");
            console.log(this.predicate);

            this.$refs.jobList.predicate = this.predicate;
            this.$refs.jobList.getData();
        }
        // select(i){
        //     console.log('Kayıt seçildi: ', i);
        //     this.$router.push('draft/' + i.Id);
        // }
    }
}
</script>